export default {
    Search: 'Найти',
    'No results found.': 'Ничего не найдено.',
    cancel: 'отменить'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/searchfield/translations/ru.js
// module id = 85
// module chunks = 0